module.exports = __webpack_public_path__ + "img/2019qinglongxia-6.511549c4.jpg";